import { useEffect, useRef } from "react";

const CHECK_EVERY_MS = 2 * 60 * 1000; // every 2 minutes

export default function AppUpdater() {
  const currentVersion = useRef(null);

  const checkVersion = async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, {
        cache: "no-store",
      });
      if (!res.ok) return;
      const { version } = await res.json();

      if (currentVersion.current === null) {
        currentVersion.current = version; // first load, remember it
      } else if (currentVersion.current !== version) {
        window.location.reload(true); // new deploy found
      }
    } catch (e) {
      // ignore network errors
    }
  };

  useEffect(() => {
    checkVersion();
    const timer = setInterval(checkVersion, CHECK_EVERY_MS);

    // also check when the user comes back to the tab
    const onVisible = () => {
      if (document.visibilityState === "visible") checkVersion();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return null;
}